import React, { useState } from 'react'
import styles from "./Works.module.css"
import img2 from "../../assets/VB.png"
import img3 from "../../assets/mbs.png"
import img1 from "../../assets/website.png"
import ai from "../../assets/vbai.png"
import ios from "../../assets/ios.png"
import WorkModel from './WorkModel'
function WorkPage() {
    const [showModel, setShowModel] = useState("")
    const[which, setWhich] = useState('')
    const [active, setActive] = useState('Website')
    const [show1, setShow1] = useState('show')
    const [show2, setShow2] = useState('hide')
    const [show3, setShow3] = useState('hide')
    const [show4, setShow4] = useState('hide')
    const [show5, setShow5] = useState('hide')
    const [show6, setShow6] = useState('hide')
    const [show7, setShow7] = useState('hide')
    //console.log("show cclass", showModel)

    const handleShow = (which) => {
        setWhich(which)
        setShowModel('showWorkModel')
    }
    const hideModel = () => {
            setShowModel("")
    }   
    
    return (
        <div className={styles.worksPage}>
            <WorkModel which = {which} show={showModel} handleShowModel={hideModel} />
            <h3 style={{ color: "#066263" }}>Work</h3>
            <div className={styles.worksTab}>
                <ul>
                    <li style={{ opacity: `${active === 'Website' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Website'); setShow1('show'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}>Website</li>
                    <li style={{ opacity: `${active === 'Android' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Android'); setShow1('hide'); setShow2('show'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}>Web Application</li>
                    <li style={{ opacity: `${active === 'AI Solution' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('AI Solution'); setShow1('hide'); setShow2('hide'); setShow3('show'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}> AI Solution</li>


                    <li style={{ opacity: `${active === 'iOS' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('iOS'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('show'); setShow5('hide'); setShow6('hide'); setShow7('hide') }}>iOS</li>

                    {/* <li style={{ opacity: `${active === 'Web3.0' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Web3.0'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('show'); setShow6('hide'); setShow7('hide') }}>Web3.0</li>

                    <li style={{ opacity: `${active === 'Business Consulting' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Business Consulting'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('show'); setShow7('hide') }}>Business Consulting</li>

                    <li style={{ opacity: `${active === 'Trading' ? "1" : "0.5"}` }} onMouseOver={(e) => { e.stopPropagation(); setActive('Trading'); setShow1('hide'); setShow2('hide'); setShow3('hide'); setShow4('hide'); setShow5('hide'); setShow6('hide'); setShow7('show') }}>Trading</li> */}
                </ul>
            </div>
            <div onMouseOver={(e) => e.stopPropagation()} className={styles.WorksSliderConatiner}>

                <div className={`${styles.workdGrid2} ${show1}`}>
                    <div  className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div onClick={()=>handleShow('website')} className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p className={styles.typeofproject}>Website / Concept make </p>
                            <h4 className={styles.typeofproject}>THE DECK</h4>
                            <p className={styles.projectdesc}>大阪のコワーキングスペースである、THE DECKの新サービ <br /> スのLPのコンセプトメイク、デザイン。</p>
                        </div>
                    </div>
                    {/* <div onClick={handleShow} className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div className={styles.workImg}>
                            <img src={img3} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div> */}

                </div>
                <div className={`${styles.workdGrid} ${show2}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div onClick={()=>handleShow('vb')} className={styles.workImg}>
                            <img src={img2} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p className={styles.typeofproject}>AI Solution </p>
                            <h4 className={styles.typeofproject}></h4>
                            <p className={styles.projectdesc}>姿勢をカメラで撮影した画像をもとに、姿勢の分析、体系の <br /> 分析を自動でAIが行うシステム。</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div  onClick={() => handleShow('mbs')} className={styles.workImg}>
                            <img src={img3} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p className={styles.typeofproject}>Web Application </p>
                            <h4 className={styles.typeofproject}>M　B　S</h4>
                            <p className={styles.projectdesc}>輸入中古車のオークションサービス。クライアントは、販売 <br /> 効率大幅に向上し、利益率も大幅に上がった。</p>
                        </div>
                    </div>
                    {/* <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div> */}
                </div>
                <div className={`${styles.workdGrid2} ${show3}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div onClick={()=>handleShow('ai')} className={styles.workImg}>
                            <img src={ai} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p className={styles.typeofproject}>AI Solution</p>
                            <h4 className={styles.typeofproject}></h4>
                            <p className={styles.projectdesc}>表情をカメラで認識し、感情などを自動でAIが分析しデータ <br /> 化する高度な技術が求められるサービス。</p>
                        </div>
                    </div>
                    {/* <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd} ${styles.mobileView}`}>
                        <div className={styles.workImg}>
                            <img src={img1} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p>Website / Concept make </p>
                            <h4>CLOUD Co.,Ltd.</h4>
                            <p>日本最大のタバコに関するウェブメディアの構築,とそのコンセプトの設計</p>
                        </div>
                    </div> */}
                </div>
                <div className={`${styles.workdGrid2} ${show4}`}>
                    <div className={`${styles.workdGridItem} ${styles.swingintopfwd}`}>
                        <div onClick={()=>handleShow('ios')} className={styles.workImg}>
                            <img src={ios} alt="" />
                        </div>
                        <div className={styles.WorkInfo}>
                            <p className={styles.typeofproject}  >App Development </p>
                            <h4 className={styles.typeofproject}>Hillside</h4>
                            <p className={styles.projectdesc}>実店舗もオンラインショップも持っていた小売店の専用アプ <br /> リを開発。物流,在庫管理も大幅に効率化実現。</p>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default WorkPage